module.exports = "<div class=\"gw-wizard-progress\" ng-if=\"ribbonVisible\">\r\n    <ul ng-click=\"toggleWizardStepDisplay()\"><!-- slide the wizard step sidebar in and out of view-->\r\n        <li ng-repeat=\"step in wizardSteps\" ng-class=\"step.styleClass\"></li>\r\n    </ul>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/wizard/templates/wizard-step-progress.html
// module id = 980
// module chunks = 0